module.exports = __webpack_public_path__ + "img/66.e87f6be9.jpg";